export function haptic(pattern = 10) {
  try {
    if (navigator.vibrate) navigator.vibrate(pattern);
  } catch {
    // unsupported
  }
}

export const hapticSuccess = () => haptic([15, 50, 15]);
export const hapticTap = () => haptic(8);
